import axios from 'axios';

const onAxiosApiCall = (api_url, method, payload) => {
  const URL = api_url;
  const userData = JSON.parse(localStorage.getItem('clientpanel'));
  let authenticationToken = '';
  if (userData !== null && api_url !== 'login') {
    authenticationToken = `Bearer ${userData.pwa_token}`;
  }
  return axios(URL, {
    method: method,
    headers: {
      'content-type': 'application/json',
      'Authorization': authenticationToken
    },
    data: payload,
  })
    .then(response => response.data)
    .catch(error => {
      throw error;
  });
};

export default onAxiosApiCall;